<template>
  <div class="panel">
    <div class="top">
      <template v-if="energyType === 'cool'"
        ><div class="ashGreyBgcComWrap top-left">
          <div class="comTitleAshGreyBgc titleStart">
            <h4>空调主机</h4>
            <TitleTips :listData="dataGather?.airHost?.title || []" />
          </div>
          <div class="comContentBoxAshGreyBgc">
            <DataPagination
              v-if="dataGather?.airHost?.contentSwitch?.length"
              :listData="dataGather?.airHost?.contentSwitch"
              className="airHostSwitch"
              classNameTitleTipsItem="airHostSwitchItem"
              useHeadTips
              combineNameUnit
            />
            <el-empty
              v-else
              class="empty"
              :image-size="80"
              description="暂无数据"
            ></el-empty>
          </div>
        </div>
        <div class="ashGreyBgcComWrap top-right">
          <div class="comTitleAshGreyBgc titleStart">
            <h4>冷却塔</h4>
            <TitleTips :listData="dataGather?.coolingTower?.title || []" />
          </div>
          <div class="comContentBoxAshGreyBgc">
            <HeadTips
              v-if="dataGather?.coolingTower?.content?.length"
              :listData="dataGather?.coolingTower?.content"
              className="coolingTowerTips"
              combineNameUnit
            />
            <el-empty
              v-else
              class="empty-two"
              :image-size="40"
              description="暂无数据"
            ></el-empty>
            <DataPagination
              v-if="dataGather?.coolingTower?.contentSwitch?.length"
              :splitNum="3"
              useBtnStyle
              hasBtnDescription
              :listData="dataGather?.coolingTower?.contentSwitch"
              style="margin-top: 10px"
            />
            <el-empty
              v-else
              class="empty-two"
              :image-size="40"
              description="暂无数据"
            ></el-empty>
          </div></div
      ></template>
      <template v-else>
        <div class="ashGreyBgcComWrap top-warm">
          <div class="comTitleAshGreyBgc titleStart">
            <h4>锅炉机组</h4>
            <TitleTips :listData="dataGather?.obtainBoilerList?.title || []" />
          </div>
          <div class="comContentBoxAshGreyBgc">
            <DataPagination
              v-if="dataGather?.obtainBoilerList?.contentSwitch?.length"
              useBtnStyle
              :listData="dataGather?.obtainBoilerList?.contentSwitch"
              :className="'contentSwitch'"
              :splitNum="4"
            />
            <el-empty
              v-else
              class="empty"
              :image-size="80"
              description="暂无数据"
            ></el-empty>
          </div>
        </div>
      </template>
    </div>
    <div class="bottom">
      <div class="left">
        <div class="ashGreyBgcComWrap left-second">
          <div class="comTitleAshGreyBgc">
            <h4>分水器/集水器</h4>
          </div>
          <div class="comContentBoxAshGreyBgc">
            <TitleTipsItem
              v-if="dataGather?.waterTools?.content?.length"
              :listData="dataGather?.waterTools?.content || []"
              :modalFlag="2"
              class="waterToolsTips"
            />
            <el-empty
              v-else
              class="empty-two"
              :image-size="60"
              description="暂无数据"
            ></el-empty>
            <TwoYAxisBar
              v-if="dataGather?.waterTools?.contentSwitch?.length"
              :listData="dataGather?.waterTools?.contentSwitch"
              :id="assetId"
            />
            <el-empty
              v-else
              class="empty-two"
              :image-size="60"
              description="暂无数据"
            ></el-empty>
          </div>
        </div>
        <div class="ashGreyBgcComWrap left-third">
          <div class="comTitleAshGreyBgc">
            <h4>环境监测</h4>
          </div>
          <div class="comContentBoxAshGreyBgc">
            <DataPagination
              v-if="dataGather?.envMonitorData?.length"
              :listData="dataGather?.envMonitorData"
              className="envMonitorDataSwitch"
              useGaugeStyle
              :chartsId="assetId"
              :split-num="4"
            />
            <el-empty
              v-else
              class="empty"
              :image-size="80"
              description="暂无数据"
            ></el-empty>
          </div>
        </div>
      </div>
      <div class="center">
        <template v-if="energyType === 'cool'">
          <div class="ashGreyBgcComWrap center-second">
            <div class="ashGreyBgcComWrap center-second-content">
              <div class="comTitleAshGreyBgc titleStart">
                <h4>冷冻水泵</h4>
                <TitleTips :listData="dataGather?.frozenWater?.title || []" />
              </div>
              <div class="comContentBoxAshGreyBgc">
                <DataPagination
                  v-if="dataGather?.frozenWater?.contentSwitch?.length"
                  useBtnStyle
                  :listData="dataGather?.frozenWater?.contentSwitch"
                  :className="
                    dataGather?.frozenWater?.contentSwitch?.length > 2
                      ? 'contentSwitch'
                      : 'contentSwitch  contentSwitchFullHeight'
                  "
                />
                <el-empty
                  v-else
                  class="empty"
                  :image-size="80"
                  description="暂无数据"
                ></el-empty>
              </div>
            </div>
            <div class="center-second-spilt"></div>
            <div class="ashGreyBgcComWrap center-second-content">
              <div class="comTitleAshGreyBgc titleStart">
                <h4>冷却水泵</h4>
                <TitleTips :listData="dataGather?.coolingWater?.title || []" />
              </div>
              <div class="comContentBoxAshGreyBgc">
                <DataPagination
                  v-if="dataGather?.coolingWater?.contentSwitch?.length"
                  useBtnStyle
                  :listData="dataGather?.coolingWater?.contentSwitch"
                  :className="
                    dataGather?.coolingWater?.contentSwitch?.length > 2
                      ? 'contentSwitch'
                      : 'contentSwitch  contentSwitchFullHeight'
                  "
                />
                <el-empty
                  v-else
                  class="empty"
                  :image-size="80"
                  description="暂无数据"
                ></el-empty>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="ashGreyBgcComWrap center-secondWarm">
            <div class="ashGreyBgcComWrap center-secondWarm-content">
              <div class="comTitleAshGreyBgc titleStart">
                <h4>暖水泵</h4>
                <TitleTips :listData="dataGather?.warmWater?.title || []" />
              </div>
              <div class="comContentBoxAshGreyBgc">
                <DataPagination
                  v-if="dataGather?.warmWater?.contentSwitch?.length"
                  useBtnStyle
                  :listData="dataGather?.warmWater?.contentSwitch"
                  :className="'contentSwitch'"
                  :splitNum="4"
                />
                <el-empty
                  v-else
                  class="empty"
                  :image-size="80"
                  description="暂无数据"
                ></el-empty>
              </div>
            </div>
          </div>
        </template>
        <div class="ashGreyBgcComWrap center-third">
          <div class="comTitleAshGreyBgc">
            <h4>{{ energyType === "cool" ? "主机能效" : "锅炉能效" }}</h4>
            <el-radio-group
              v-model="hostEnergyType"
              @change="changeHostEnergyType"
              size="mini"
            >
              <el-radio-button label="DAY">今日</el-radio-button>
              <el-radio-button label="MONTH">本月</el-radio-button>
              <el-radio-button label="YEAR">今年</el-radio-button>
            </el-radio-group>
          </div>
          <div class="comContentBoxAshGreyBgc center-third-content">
            <template
              v-if="
                activeEnergyData?.topNode?.length ||
                activeEnergyData?.bottomNode?.length
              "
            >
              <div
                :class="
                  energyType === 'cool'
                    ? 'center-third-content-left'
                    : 'center-third-content-left center-third-content-leftWarm'
                "
              >
                <HeadTips
                  :listData="activeEnergyData?.topNode"
                  combineNameUnit
                  className="hostEnergyData"
                />
              </div>
              <div
                v-if="energyType === 'cool'"
                class="center-third-content-right"
              >
                <Liquidfill
                  :listData="activeEnergyData?.bottomNode"
                  :assetId="assetId"
                />
              </div>
            </template>
            <el-empty
              v-else
              class="empty-togather"
              :image-size="80"
              description="暂无数据"
            ></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeadTips from "@/components/HeadTips/HeadTips";
import TitleTips from "@/components/TitleTips/TitleTips.vue";
import TitleTipsItem from "@/components/TitleTips/TitleTipsItem.vue";
import DataPagination from "../DataPagination.vue";
import Liquidfill from "./Liquidfill.vue";
import TwoYAxisBar from "./TwoYAxisBar.vue";
export default {
  components: {
    HeadTips,
    TitleTips,
    TitleTipsItem,
    DataPagination,
    Liquidfill,
    TwoYAxisBar,
  },
  name: "CenterPanel",
  props: {
    dataGather: {
      type: Object,
      default: () => ({
        //空调主机
        airHost: {
          title: [],
          contentSwitch: [],
        },
        //分水，集水
        waterTools: {
          content: [],
          contentSwitch: [],
        },
        //冷却塔
        coolingTower: {
          title: [],
          content: [],
          contentSwitch: [],
        },
        //冷冻水泵
        frozenWater: {
          title: [],
          contentSwitch: [],
        },
        //冷却水泵
        coolingWater: {
          title: [],
          contentSwitch: [],
        },
        //环境监测
        envMonitorData: [],
        //主机能效
        hostEnergyData: {
          topNode: [],
          bottomNode: [],
        },
        //锅炉机组
        obtainBoilerList: {
          title: [],
          contentSwitch: [],
        },
        //暖水泵
        warmWater: {
          title: [],
          contentSwitch: [],
        },
        //锅炉能效
        boilerEnergyData: {
          topNode: [],
          bottomNode: [],
        },
      }),
    },
    assetId: {
      type: String,
      default: "",
    },
    //空调模式：cool - 制冷， gc - 燃气制热， ec - 电制热， ac - 空气源热泵制热
    energyType: {
      type: String,
      default: "cool",
    },
  },
  data() {
    return {
      hostEnergyType: "DAY",
    };
  },
  computed: {
    activeEnergyData: function () {
      return this.energyType === "cool"
        ? this.dataGather?.hostEnergyData
        : this.dataGather?.boilerEnergyData;
    },
  },
  methods: {
    changeHostEnergyType() {
      if (this.energyType === "cool") {
        this.$bus.$emit(
          "getHostEnergyEfficiency",
          this.assetId,
          this.hostEnergyType
        );
      } else {
        this.$bus.$emit(
          "getBoilerEnergyEfficiency",
          this.assetId,
          this.hostEnergyType
        );
      }
    },
    //将4个value组成一组
    dealEnvMonitorData(data) {
      const newData = [];
      let obj = { name: 1, value: [] };
      Array.isArray(data) &&
        data.forEach((element, index) => {
          obj.value.push(element);
          if (index % 4 == 3) {
            newData.push(obj);
            obj = { name: index, value: [] };
          }
        });
      return newData;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.panel {
  width: calc(100% - 40px);
  // display: flex;
  // background-color: #f7f7f7;
  padding: 0 20px;
  // @include setFlexBetween;

  .titleStart {
    @include setFlexStart;
  }
  .top {
    height: 260px;
    width: 100%;
    @include setFlexBetween;
    &-left {
      width: 49%;
      height: 100%;
      ::v-deep .airHostSwitch {
        height: 210px;
        padding-top: 20px;

        & > div:nth-child(1) {
          height: 155px;
          align-items: flex-start;
          flex-direction: column;
          width: calc(100% - 40px);
          padding: 0 20px;

          & > div {
            width: 100%;
            height: 45%;
            align-items: center;
          }
        }

        & > div:nth-child(2) {
          margin-top: 5px;
        }

        & .datas {
          width: 100%;
          flex-direction: row;
          height: 40%;

          &-name {
            color: #333;
            font-size: 16px;
            font-weight: bold;
            width: 200px;
          }

          &-value {
            width: calc(100% - 200px);
          }
        }
      }

      ::v-deep .airHostSwitchItem {
        // height: 100%;

        & > div {
          width: 150px;
          justify-content: center;
        }

        & > div .firstDiv {
          .highlight {
            font-size: 18px;
            color: #333;
          }

          .bold {
            font-size: 16px;
          }
        }

        & > div .secondDiv {
          margin-top: 5px;
          color: #666;
          font-size: 12px;
        }
      }
    }
    &-right {
      width: 49%;
      height: 100%;
      ::v-deep .coolingTowerTips {
        width: 100%;
        height: 80px;
        margin-top: 10px;
        color: #666;

        & > div .firstDiv {
          .highlight {
            font-size: 22px;
            color: #333;
          }

          .bold {
            font-size: 16px;
          }
        }

        & > div .secondDiv {
          margin-top: 5px;
          color: #666;
          font-size: 12px;
        }
      }

      ::v-deep .coolingTowerSwitch {
        & > div:nth-child(1) > div > div:nth-child(2) {
          margin-top: 20px;
        }
      }

      ::v-deep .coolingTowerSwitchItem {
        & > div {
          width: 150px;
          justify-content: center;

          .itemValue {
            font-size: 16px;
          }
        }
      }
    }
    &-warm {
      width: 100%;
      height: 100%;
      ::v-deep .contentSwitch {
        height: 240px;
        & > div:nth-child(1) {
          height: 180px;
          justify-content: space-evenly;
          align-content: center;
          width: calc(100% - 60px);
          padding: 0 30px;
          & .datasBtnExtend {
            width: 24%;
            height: 60%;
            & .datasBtn-name-state{
              width: 70px;
            }
          }
        }
      }
    }
  }
  .bottom {
    margin-top: 8px;
    @include setFlexBetween;
    .left {
      width: 49%;
      @include setFlexColumn;

      &-second {
        height: 350px;
        width: 100%;

        ::v-deep .waterToolsTips {
          height: 80px;
          margin-top: 10px;
          justify-content: space-evenly;
          flex-direction: column;

          & > div {
            width: 33%;
            max-width: 33%;
            justify-content: center;

            .itemName {
              font-size: 12px;
            }
          }
        }

        ::v-deep .waterToolsTipsSwitch {
          height: 130px;

          .datas {
            width: 200px;
          }
        }

        ::v-deep .waterToolsTipsSwitchOne > div:nth-child(1) {
          height: 130px;

          .datas {
            width: 200px;
            height: 100%;

            &-value {
              height: 100%;

              & > div {
                height: 100%;
              }
            }
          }
        }

        ::v-deep .waterToolsTipsSwitchItem {
          flex-direction: column;
          // height: 75px;

          & > div {
            width: 200px;
            justify-content: center;

            .itemValue {
              max-width: 75px;
              font-size: 16px;
            }
          }
        }
      }

      &-third {
        width: 100%;
        height: 250px;
      }
    }

    .center {
      width: 49%;
      @include setFlexColumn;

      &-second {
        height: 350px;
        width: 100%;
        background-color: #f7f7f7;
        @include setFlexBetween;

        &-content {
          flex-grow: 1;
          width: 306px;

          ::v-deep .contentSwitch {
            height: 280px;
            padding-top: 20px;

            & > div:nth-child(1) {
              height: 230px;
              flex-direction: column;
              justify-content: space-around;
              width: calc(100% - 40px);
              padding: 0 20px;
            }

            & > div:nth-child(2) {
              margin-top: 22px;
            }
          }

          ::v-deep .contentSwitchFullHeight > div:nth-child(1) {
            height: 100%;
          }
        }

        &-spilt {
          flex-grow: 0;
          width: 8px;
          height: 100%;
          background-color: #ffffff;
        }
      }
      &-secondWarm {
        height: 350px;
        width: 100%;
        background-color: #f7f7f7;
        // @include setFlexBetween;

        ::v-deep .contentSwitch {
          height: 280px;
          padding-top: 20px;

          & > div:nth-child(1) {
            height: 230px;
            flex-wrap: wrap;
            justify-content: space-between;
            align-content: flex-start;
            width: calc(100% - 60px);
            padding: 0 30px;
            & .datasBtnExtend {
              width: 45%;
              margin-bottom: 2%;
            }
          }
        }
      }
      &-third {
        width: 100%;
        height: 250px;

        &-content {
          @include setFlexBetween;

          &-left {
            width: 50%;
            height: 100%;

            ::v-deep .hostEnergyData {
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #666666;

              & > div {
                width: 50%;

                .firstDiv {
                  .highlight {
                    font-size: 22px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: bold;
                    color: #333333;
                  }

                  .bold {
                    font-size: 18px;
                  }
                }

                .secondDiv {
                  margin-top: 5px;
                }
              }
            }
          }

          &-right {
            width: 50%;
            height: 100%;
          }

          &-leftWarm {
            width: 100%;
          }
        }
      }
    }
  }

  .empty-two {
    padding: 5px 0;
  }

  .empty-togather {
    width: 100%;
  }
  ::v-deep .TitleTipsItem > div .itemName{
    width: 45px;
  }
}

::v-deep .el-pagination .btn-prev,
::v-deep .el-pagination .btn-next {
  background-color: #f8fafb;
}

::v-deep .el-pagination button:disabled {
  background-color: inherit;
}

::v-deep .el-pagination .el-pager li:not(.disabled) {
  background-color: #f8fafb;
}

::v-deep .el-pagination .el-pager li:not(.disabled).active {
  background-color: #f8fafb;
}
</style>
